// extracted by mini-css-extract-plugin
module.exports = {"link":"SubMenu_link__q5IdR","disabled":"SubMenu_disabled__8iEnO","borderRight":"SubMenu_borderRight___EHmT"};